import React from 'react';
import { TENANT_STATUS_CONFIG, USER_STATUS_CONFIG, ROLE_CONFIG } from '../../types';

type StatusType = 'tenant' | 'user' | 'role' | 'membership' | 'request';

interface StatusBadgeProps {
  value: string;
  type?: StatusType;
  className?: string;
}

const MEMBERSHIP_STATUS: Record<string, { label: string; color: string; bgColor: string }> = {
  active: { label: 'Active', color: 'text-emerald-700', bgColor: 'bg-emerald-50' },
  inactive: { label: 'Inactive', color: 'text-red-700', bgColor: 'bg-red-50' },
  pending: { label: 'Pending', color: 'text-amber-700', bgColor: 'bg-amber-50' },
};

const REQUEST_STATUS: Record<string, { label: string; color: string; bgColor: string }> = {
  pending: { label: 'Pending', color: 'text-amber-700', bgColor: 'bg-amber-50' },
  approved: { label: 'Approved', color: 'text-emerald-700', bgColor: 'bg-emerald-50' },
  rejected: { label: 'Rejected', color: 'text-red-700', bgColor: 'bg-red-50' },
  completed: { label: 'Completed', color: 'text-blue-700', bgColor: 'bg-blue-50' },
};

const DEFAULT_CFG = { label: '', color: 'text-slate-600', bgColor: 'bg-slate-100' };

export const StatusBadge: React.FC<StatusBadgeProps> = ({ value, type = 'user', className = '' }) => {
  const key = String(value || '').toLowerCase();
  let cfg: { label: string; color: string; bgColor: string; borderColor?: string };

  switch (type) {
    case 'tenant': {
      const c = TENANT_STATUS_CONFIG[key] || DEFAULT_CFG;
      cfg = c;
      break;
    }
    case 'role':
      cfg = ROLE_CONFIG[key] || { label: key.replace(/_/g, ' '), color: 'text-slate-600', bgColor: 'bg-slate-100' };
      break;
    case 'membership':
      cfg = MEMBERSHIP_STATUS[key] || DEFAULT_CFG;
      break;
    case 'request':
      cfg = REQUEST_STATUS[key] || DEFAULT_CFG;
      break;
    default:
      cfg = USER_STATUS_CONFIG[key] || DEFAULT_CFG;
  }

  const label = cfg.label || key.replace(/_/g, ' ');
  const borderColor = (cfg as { borderColor?: string }).borderColor || 'border-transparent';

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold capitalize ${cfg.bgColor} ${cfg.color} ${borderColor} ${className}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
